import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import store from './store'
import i18n from './i18n'
import VeeValidate from 'vee-validate'
import api from './helpers/ApiHelper'

// partie authentification
import auth from './auth'

// dès que c'est pret
document.addEventListener('deviceready', onDeviceReady, false);
function onDeviceReady() {
  store.commit('setDevice', device)
  // auth passive
  auth.silentLogin(device)
}

// production
Vue.config.productionTip = true
if (process.env.NODE_ENV === 'development') {
  Vue.config.productionTip = false
}

// validation de fomulaire
Vue.use(VeeValidate, {
  i18nRootKey: 'form_validation', // chemin racine des messages
  i18n
})

// api à disposition
Vue.mixin({
  data: function () {
    return {
      api: api
    }
  }
})

export default new Vue({
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')

// initialise la lang
store.dispatch('initLang')

// initialise le four séléctionné
store.dispatch('initOven')

// développeur
if (process.env.NODE_ENV === 'development') {
  // la clé coté serveur doit être : azerty123456789
  store.commit('setJwt', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwibmFtZSI6IkRhbWllbiIsImVtYWlsIjoiZGF3YWRhbUBnbWFpbC5jb20iLCJpc1N1cGVyQWRtaW4iOnRydWUsImlzQWRtaW4iOnRydWUsImlhdCI6MTU1MzMzOTIwMn0.Zma8jJgsSHYLeSP0VOBbgUKCAe9Fz7BlkKGppAXvqXM')
}
